const PARTICIPANT_TITLE_TEXT_KEYS: Record<string, string> = {
  mr: 'checkout_steps_participants_form_field_title_mr_text',
  ms: 'checkout_steps_participants_form_field_title_ms_text',
  mrs: 'checkout_steps_participants_form_field_title_ms_text',
  kidmale: 'checkout_steps_participants_form_field_title_kid_male_text',
  kidfemale: 'checkout_steps_participants_form_field_title_kid_female_text',
  babymale: 'checkout_steps_participants_form_field_title_baby_male_text',
  babyfemale: 'checkout_steps_participants_form_field_title_baby_female_text',
}

export function getParticipantTitleTextKey(title: string | undefined): string | null {
  if (!title) {
    return null
  }
  const normalizedTitle = title
    .trim()
    .toLowerCase()
    .replaceAll('.', '')

  return PARTICIPANT_TITLE_TEXT_KEYS[normalizedTitle] ?? null
}
